import { sendRequest } from "../../hooks/requests/useRequest";

export async function getTypeSamples() {
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `TypeSamples/List`);

    if (response.code === 200)
        return response.data;
    else
        return response;
}

export async function saveSampling({
    date_collected, factor_correction, folio, id_mic_detail_sample, id_mic_sample, id_mic_sampling, id_mic_site, id_mic_site_areas,
    id_mic_type_sample, id_patient, id_quoter, id_quoter_type_sample, id_thermometer, not_collected, observations, quantity, required_temperature,
    temperature, subject
}) {
    const body = {
        date_collected,
        factor_correction,
        folio,
        id_mic_detail_sample,
        id_mic_sample,
        id_mic_sampling,
        id_mic_site,
        id_mic_site_areas,
        id_mic_type_sample,
        id_patient,
        id_quoter,
        id_quoter_type_sample,
        id_thermometer,
        not_collected,
        observations,
        quantity,
        required_temperature,
        temperature,
        subject
    };


    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, "QuoterDeterminations/SaveIndividualSample"
    );

    if (response.code === 200)
        return {
            code: response?.code,
            data: response?.data,
        }

    else if (response.code === 401)
        return response.data;
    else
        return response.data;

}

export async function getSites() {
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Sites/List`);

    if (response.code === 200)
        return response.data;
    else
        return response;
}

export async function getAreas(_id_mic_site) {
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `SitesAreas/List/${_id_mic_site}`);

    if (response.code === 200)
        return response.data;
    else
        return response;
}

export async function getSamples() {
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `SampleMic/List`);

    if (response.code === 200)
        return response.data;
    else
        return response;
}

export async function getThermometers() {
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Thermometers/List`);

    if (response.code === 200)
        return response.data;
    else
        return {
            code: response?.code,
            data: response?.data.msg,
        };
}


export async function saveQuoter({
    cotizacion, observations, firm_sampler, firm_client, firm_superv, sampling_plan
}) {
    const body = {
        cotizacion,
        observations,
        firm_sampler,
        firm_client,
        firm_superv,
        sampling_plan
    };

    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, "QuoterDeterminations/SaveQuoter"
    );

    if (response.code === 200)
        return {
            code: response?.code,
            data: response?.data,
        }

    else if (response.code === 401)
        return response.data;
    else
        return {
            code: response?.code,
            data: response?.data.msg,
        };

}


export async function saveWorkOrderMicro({
    id_branch, id_commercial_line, id_quoter, iva, listPayMethods, required_invoice_patient, required_invoice, payment_company, calculate_amount
}) {
    const body = {
        id_branch,
        id_commercial_line,
        id_quoter,
        iva,
        listPayMethods,
        required_invoice_patient,
        required_invoice,
        payment_company,
        calculate_amount
    };

    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, "WorkOrder/CreteMicro"
    );

    if (response.code === 200) {
        return {
            code: response?.code,
            data: response?.data,
        };
    } else if (response.code === 409) {
        return {
            code: response?.code,
            data: response?.data.msg,
        };
    } else if (response.code === 401) {
        return response.data;
    } else {
        return {
            code: response?.code,
            data: response?.data.msg,
        };
    }
}


export async function saveSampleM({
    name
}) {
    const body = {
        name
    };

    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, "SampleMic"
    );

    if (response.code === 200)
        return {
            code: response?.code,
            data: response?.data,
        }

    else if (response.code === 401)
        return response.data;
    else
        return {
            code: response?.code,
            data: response?.data.msg,
        };

}


export async function saveSite({
    name
}) {
    const body = {
        name
    };

    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, "Sites/Create"
    );

    if (response.code === 200)
        return {
            code: response?.code,
            data: response?.data,
        }

    else if (response.code === 401)
        return response.data;
    else
        return {
            code: response?.code,
            data: response?.data.msg,
        };

}

export async function saveUpdateSampling({
    date_collected, factor_correction, folio, id_mic_detail_sample, id_mic_sample, id_mic_sampling, id_mic_site, id_mic_site_areas,
    id_mic_type_sample, id_patient, id_quoter, id_quoter_type_sample, id_thermometer, not_collected, observations, quantity, required_temperature,
    temperature, subject
}) {
    const body = {
        date_collected,
        factor_correction,
        folio,
        id_mic_detail_sample,
        id_mic_sample,
        id_mic_sampling,
        id_mic_site,
        id_mic_site_areas,
        id_mic_type_sample,
        id_patient,
        id_quoter,
        id_quoter_type_sample,
        id_thermometer,
        not_collected,
        observations,
        quantity,
        required_temperature,
        temperature,
        subject
    };


    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, "QuoterDeterminations/UpdateIndividualSample"
    );

    if (response.code === 200)
        return {
            code: response?.code,
            data: response?.data,
        }

    else if (response.code === 401)
        return response.data;
    else if (response.code === 500)
        return {
            code: response?.code,
            data: "Error al guardar la recolección de la muestra",
        }
    else
        return response.data;

}

// ? 
export async function getReturnReasonsSample() {
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `ReturnReasonMicro/List`);

    if (response.code === 200)
        return response.data;
    else
        return response;
}


// ?
export async function saveDeleteSampling({
    id_work_order, id_work_order_exam, id_work_order_profile, id_mic_detail_sample,
    id_user_autorized, id_mic_return_reason, amount, id_branch,
    is_mic_detail_sample, amount_liquided
}) {
    const body = {
        id_work_order,
        id_work_order_exam,
        id_work_order_profile,
        id_mic_detail_sample,
        id_user_autorized,
        id_mic_return_reason,
        amount,
        id_branch,
        is_mic_detail_sample,
        amount_liquided
    };

    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, "QuoterDeterminations/CancelSample"
    );

    if (response.code === 200)
        return {
            code: response?.code,
            data: response?.data,
        }

    else if (response.code === 401)
        return response.data;
    else if (response.code === 500)
        return {
            code: response?.code,
            data: "Error al cancelar la muestra",
        }
    else
        return response.data;

}



export async function saveUpdateSample({
    id_mic_detail_sample, is_change, id_mic_sample, name_sample,
}) {
    const body = {
        id_mic_detail_sample,
        is_change,
        id_mic_sample,
        name_sample,

    };

    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, "QuoterDeterminations/UpdateSample"
    );

    if (response.code === 200)
        return {
            code: response?.code,
            data: response?.data,
        }

    else if (response.code === 401)
        return {
            code: response?.code,
            data: response?.data,
        }
    else if (response.code === 500)
        return {
            code: response?.code,
            data: response?.data,
        }
    else
        return response.data;

}

// ? CHANGE SITE
export async function saveUpdateChangeSample({
    id_mic_detail_sample, is_change, id_mic_site, name_site,
}) {
    const body = {
        id_mic_detail_sample,
        is_change,
        id_mic_site,
        name_site,
    };

    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, "QuoterDeterminations/ChangeSample"
    );

    if (response.code === 200)
        return {
            code: response?.code,
            data: response?.data,
        }

    else if (response.code === 401)
        return {
            code: response?.code,
            data: response?.data,
        }
    else if (response.code === 500)
        return {
            code: response?.code,
            data: response?.data,
        }
    else
        return response.data;

}


// ? CHANGE OBSERVATION
export async function saveUpdateChangeObservation({
    id_mic_detail_sample, observation
}) {
    const body = {
        id_mic_detail_sample,
        observation
    };

    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, "QuoterDeterminations/ChangeObservation"
    );

    if (response.code === 200)
        return {
            code: response?.code,
            data: response?.data,
        }

    else if (response.code === 401)
        return {
            code: response?.code,
            data: response?.data,
        }
    else if (response.code === 500)
        return {
            code: response?.code,
            data: response?.data,
        }
    else
        return response.data;

}











